import * as React from 'react';
import { filter, flow, head } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { Button, Grid } from 'react-bootstrap';
import { getFormValues } from 'redux-form';
import { IAddress, ITraveller } from '../../../../../../../data/api/models';
import { IMtaFormNames, IPersonalDetailsForm } from '../../../../../../../services/mta/models';
import { FaCog } from 'react-icons/fa';
import { MTAButtons } from '../../MTAButtons';
import { MTACardHeader } from '../../CoverDetails/scenes/Components/MTACardHeader';
import { MTASummaryOverview } from '../../CoverDetails/scenes/Components/MTASummaryOverview';

interface IPersonalDetailsSummaryProps {
  handleBackButton: () => {};
  handleSubmit: () => {};
  disableButton: boolean;
  formValues: IPersonalDetailsForm;
  selectedPolicy?: any
}

class PersonalDetailsSummary extends React.Component<IPersonalDetailsSummaryProps, any> {

  private renderTravellerDetails = (travellers: ITraveller[]) => {
    if (travellers && travellers.length) {
      return (
        travellers.map((traveller: ITraveller, index) => {
          return (
            <div className="card-panel" key={index}>
              <div className="card-panel__title">
                <strong>
                  {index === 0 ? 'Lead Traveller Details' : `Traveller ${index + 1} Details`}
                </strong>
              </div>
              <div className={'card-panel__field'}>
                {traveller.title + ' ' + traveller.firstName + ' ' + traveller.lastName}
              </div>
            </div>
          );
        }));
    }
  }

  private renderTravellerEmail = (email: string) => {
    return (
      <div className="card-panel">
        <div className="card-panel__title">
          <strong>Email Address</strong>
        </div>
        <div className={'card-panel__field'}>
          {email}
        </div>
      </div>
    );
  }

  private renderTravellerPostcode = (address: IAddress) => {
    return (
      <>
        <div className="card-panel">
          <div className="card-panel__title">
            <strong>Postcode</strong>
          </div>
          <div className={'card-panel__field'}>
            {address.postcode}
          </div>
        </div>
        <div className="card-panel">
          <div className="card-panel__title">
            <strong>Address</strong>
          </div>

          <div className={'card-panel__field'}>
            <div>{address.line1}</div>
            <div className="mt-15">{address.line2}</div>
            <div className="mt-15">{address.line3}</div>
            <div className="mt-15">{address.town}</div>
            <div className="mt-15">{address.county}</div>
          </div>
        </div>
      </>
    );
  }

  private renderTravellerPhone = (phone: string) => {
    return (
      <div className="card-panel">
        <div className={'card-panel__title'}>
          <strong>Telephone</strong>
        </div>
        <div className={'card-panel__field'}>
          {phone}
        </div>
      </div>
    );
  }

  private renderMTASummaryDetails = () => {
    const { selectedPolicy } = this.props;
    const selectedPremium = head(filter(selectedPolicy.premiums, ['scheme.id', selectedPolicy.metadata?.scheme_id])) || [];

    return (
      <div className={'personal-details-overview-container'}>
        <div className={'personal-details-overview-row blue_text'}><b>Here's a summary of your policy if you continue to
          pay and
          confirm this change.</b>
        </div>
        <MTASummaryOverview
          policyApplication={selectedPolicy}
          selectedScheme={selectedPremium}
          noPadding={true}
        />
      </div>
    )
  }

  public render() {
    const { handleBackButton, handleSubmit, disableButton, formValues } = this.props;
    const buttonBack = (
      <Button
        bsStyle="primary"
        type="button"
        bsSize="small"
        className="medium-width secondary-button pull-left"
        onClick={handleBackButton}
      >
        GO BACK
      </Button>
    );

    const buttonSubmit = (
      <Button
        bsStyle="primary"
        type="button"
        bsSize="small"
        className="medium-width secondary-button pull-right"
        disabled={disableButton}
        onClick={handleSubmit}
      >
        {disableButton ? <FaCog className="fa-spin"/> : 'CONFIRM'}
      </Button>
    );

    return (
      <div>
        <div className="admiral-card" style={{ maxWidth: '750px', margin: '0 auto' }}>
          <MTACardHeader
            text={'Please check and confirm the below changes to be applied to your policy.'}
            icon={'edit'}
          />

          <div className="body">
            <Grid fluid={true}>
              {/*Travellers*/}
              <div>
                {this.renderTravellerDetails(formValues.travellers)} </div>
              {/*Email*/}
              <div>
                {this.renderTravellerEmail(formValues.travellers[0].email)}
              </div>
              {/*Phone*/}
              <div>
                {this.renderTravellerPhone(formValues.travellers[0].phone)}
              </div>
              {/*Postcode*/}
              <div>
                {this.renderTravellerPostcode(formValues.travellers[0].address)}
              </div>
              {this.renderMTASummaryDetails()}
            </Grid>
          </div>
        </div>
        <div style={{ maxWidth: '750px', margin: '15px auto' }}>
          <MTAButtons button1={buttonBack} button2={buttonSubmit}/>
        </div>
      </div>

    );
  }
}

export default flow([
  connect((state: IStore) => ({
      auth: state.auth,
      formValues: getFormValues(IMtaFormNames.PERSONAL_DETAILS)(state),
    }),
  ),
])(PersonalDetailsSummary);
